<script>
import DataProvider from './DataProvider.vue';
import JobMetaClubRepository from '../../js/repository/JobMetaClubRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: JobMetaClubRepository.findForClubAndDatevExport,
                params: [this.clubId],
                callback: this.callback,
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
